
import { defineComponent } from "vue";

export default defineComponent({
  name: "ErrorInformation",
  components: {},
  setup() {
    return {};
  },
});
